// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Svg_container__r3pJH{
    width: 30vw;
    height: 10vw;
    display: flex;
    flex-direction: column;
}

.Svg_svg-img__fBQ0W{
    width: 10vw;
    height: 5vw;
    margin: auto;
    margin-bottom: 1vw;
}

.Svg_svg-text__cFQut{
    font-size: 1.4vw;
    margin: auto;
    margin-top: 0;
    width: 16vw;
    font-family: dm-sans-light;
}

.Svg_svg1-text__u0UHh{
    width: 14vw;
}

@media(max-width: 768px){
    .Svg_container__r3pJH{
        width: 50vw;
        min-height: 30vw;
        display: flex;
        flex-direction: column;
    }
    
    .Svg_svg-img__fBQ0W{
        width: 20vw;
        height: 15vw;
        margin: auto;
        margin-bottom: 2vw;
    }
    
    .Svg_svg-text__cFQut{
        font-size: 3.5vw;
        margin: auto;
        margin-top: 0;
        width: 40vw;
    }
    
    .Svg_svg1-text__u0UHh{
        width: 25vw;

    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ExplorerClub/Svg.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;AACJ","sourcesContent":[".container{\n    width: 30vw;\n    height: 10vw;\n    display: flex;\n    flex-direction: column;\n}\n\n.svg-img{\n    width: 10vw;\n    height: 5vw;\n    margin: auto;\n    margin-bottom: 1vw;\n}\n\n.svg-text{\n    font-size: 1.4vw;\n    margin: auto;\n    margin-top: 0;\n    width: 16vw;\n    font-family: dm-sans-light;\n}\n\n.svg1-text{\n    width: 14vw;\n}\n\n@media(max-width: 768px){\n    .container{\n        width: 50vw;\n        min-height: 30vw;\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .svg-img{\n        width: 20vw;\n        height: 15vw;\n        margin: auto;\n        margin-bottom: 2vw;\n    }\n    \n    .svg-text{\n        font-size: 3.5vw;\n        margin: auto;\n        margin-top: 0;\n        width: 40vw;\n    }\n    \n    .svg1-text{\n        width: 25vw;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Svg_container__r3pJH`,
	"svg-img": `Svg_svg-img__fBQ0W`,
	"svg-text": `Svg_svg-text__cFQut`,
	"svg1-text": `Svg_svg1-text__u0UHh`
};
export default ___CSS_LOADER_EXPORT___;
